import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { ChevronDownIcon, ChevronUpIcon } from 'assets/icons';
import { addOperation, getCurrentEstimate } from 'domains/estimate/Estimate.store';
import { SOperationsWrapper } from 'pages/EstimatePage/TableSection/Operations/EstimateOperations.styled';
import EstimateOperationSection from 'pages/EstimatePage/TableSection/Operations/EstimateOperationSection';
import { AddRowButton, CollapsibleContent } from 'pages/EstimatePage/TableSection/TableSection.styled';
import { Flex, Icon, Text } from 'UI';

const EstimateOperations = ({ estimateId }: { estimateId: string }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const estimate = useSelector(getCurrentEstimate);
  const estimateOperations = estimate?.operationSection.operations ?? [];
  const [collapsed, setCollapsed] = useState(false);

  const addNewOperation = () => {
    dispatch(addOperation());
  };

  return (
    <SOperationsWrapper direction={'column'}>
      <Flex align={'center'} gap={8}>
        <Icon
          IconComponent={collapsed ? ChevronDownIcon : ChevronUpIcon}
          mt={5}
          size={22}
          onClick={() => setCollapsed((prev) => !prev)}
          data-cy={'estimate-operations-collapse-toggle'}
        />
        <Text type="heading2" disableGutter>
          {t('estimate.operations.title', 'Operations')}
        </Text>
        <Flex size={1} justify={'flex-end'}>
          <AddRowButton size={'middle'} shape={'square'} onClick={addNewOperation}>
            {t('estimate.action.add_operation', 'Add Operation')}
          </AddRowButton>
        </Flex>
      </Flex>
      <CollapsibleContent $collapsed={collapsed} $margin={'6px 0 0 0'}>
        {estimateOperations.length > 0 && (
          <div>
            <Flex direction={'column'} gap={10} padding={'0 10px'}>
              {estimateOperations.map((operation, i) => (
                <EstimateOperationSection
                  key={`${operation.name}_${i}`}
                  operation={operation}
                  estimateId={estimateId}
                />
              ))}
            </Flex>
          </div>
        )}
      </CollapsibleContent>
    </SOperationsWrapper>
  );
};

export default EstimateOperations;
